import {ProgramdayModel} from 'models/program/ProgramdayModel'
import {ProgramModel} from 'models/program/ProgramModel'
import {SequenceSessionModel} from 'models/program/SequenceSessionModel'
import {SessionModel} from 'models/program/SessionModel'
import {ImageType, SummitType, WysiwygType} from 'types'
import {Memoize} from 'util/memoize'

export type SpeakerData = {
	id: number
	url: string
	image: ImageType
	company: string
	domain: Array<string>
	firstname: string
	lastname: string
	summit: SummitType | Array<SummitType>
	bio: WysiwygType
	social: {
		facebook: string
		twitter: string
		linkedin: string
	}
	type: Array<{title: string}>
	facebook: string
	twitter: string
	linkedin: string
	hide_from_overview: boolean
}

export class SpeakerModel {
	program: ProgramModel
	data: SpeakerData

	constructor(program: ProgramModel, data: SpeakerData) {
		this.program = program
		this.data = data
	}

	@Memoize()
	get sessions(): Array<SessionModel | SequenceSessionModel> {
		return this.program.sessions.filter(session =>
			session.speakers.find(speaker => speaker === this)
		)
	}

	@Memoize()
	get types(): Array<string> {
		if (!this.data.type?.length) return []
		return this.data.type.map(t => t?.title).filter(type => type)
	}

	@Memoize()
	get day(): ProgramdayModel {
		return null
	}

	@Memoize()
	get url(): string {
		return this.data.url
	}

	@Memoize()
	get path(): string {
		return this.program.generatePathFromUrl(this.url)
	}

	@Memoize()
	get domains(): Array<string> {
		return this.data.domain
	}

	@Memoize()
	get id(): number {
		return this.data.id
	}

	@Memoize()
	get summits(): Array<SummitType> {
		if (typeof this.data.summit === 'string') return [this.data.summit]
		return this.data.summit
	}

	@Memoize()
	get summitsSet(): Set<SummitType> {
		return new Set(this.summits)
	}

	@Memoize()
	get firstname(): string {
		return this.data.firstname
	}

	@Memoize()
	get lastname(): string {
		return this.data.lastname
	}

	@Memoize()
	get name(): string {
		return this.data.firstname + ' ' + this.data.lastname
	}

	@Memoize()
	get biography(): WysiwygType {
		return this.data.bio
	}
}
